import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, startDate: String, endDate: String }

  connect() {
    this.params = {}
    new URLSearchParams(window.location.search).forEach((v, k) => {
      this.params[k] = v
    })
    this.element.querySelectorAll("select[name]").forEach((el) => {
      if (el.name && el.value) this.params[el.name] = el.value
    })
    if (this.startDateValue)
      this.params["target_date_start"] = this.startDateValue
    if (this.endDateValue) this.params["target_date_end"] = this.endDateValue
  }

  reload(event) {
    const { name, value } = event.target
    if (name) this.params[name] = value
    this.#fetch()
  }

  dateRangeFilter(event) {
    const { startDate, endDate } = event.detail
    if (startDate) this.params["target_date_start"] = startDate
    if (endDate) this.params["target_date_end"] = endDate
    this.#fetch()
  }

  #fetch() {
    const url = new URL(this.urlValue, window.location.origin)
    Object.entries(this.params).forEach(([k, v]) => {
      if (v !== "" && v != null) url.searchParams.set(k, v)
    })

    fetch(url, { headers: { Accept: "application/json" } })
      .then((r) => r.json())
      .then((data) => {
        if (data.stream) Turbo.renderStreamMessage(data.stream)
      })
  }
}
